import PermanentLeft from './PermanentLeft';
export default PermanentLeft;
